import { IMyReportsReport } from "../../../Models/IMyReportsReport";
import { IGCPBigQueryJob } from "../../../Models/Models";
import { IBaseAction } from "../Actions/BaseAction";
import { App } from "../Enums/App";
import { IReportProgress } from "../Models/IReportProgress";
import { IGetJobsRequest } from "../Models/Requests/IGetJobsRequest";

export type SetLoadingReportsAction = IBaseAction<boolean>;
export type GetReportsInitiateAction = IBaseAction<IGetJobsRequest>;
export type GetReportsSuccessAction = IBaseAction<IMyReportsReport[]>;
export type GetReportsFailureAction = IBaseAction<string>;
export type GetRecentReportsInitiateAction = IBaseAction<App>;
export type GetRecentReportsSuccessAction = IBaseAction<IGCPBigQueryJob[]>;
export type GetRecentMatchReportsSuccessAction = IBaseAction<IGCPBigQueryJob[]>;
export type GetRecentMobilyticsReportsSuccessAction = IBaseAction<IGCPBigQueryJob[]>;
export type GetRecentReportsFailureAction = IBaseAction<string>;
export type SetReportProgress = IBaseAction<IReportProgress>;
export type SetDeletingReportAction = IBaseAction<boolean>;
export type DeleteReportInitiateAction = IBaseAction<string>;
export type SetDeletingReportSuccessAcction = IBaseAction<string>;

export type ReportActionType =
    SetLoadingReportsAction |
    GetReportsInitiateAction |
    GetReportsSuccessAction |
    GetReportsFailureAction |
    GetRecentReportsInitiateAction |
    GetRecentReportsSuccessAction |
    GetRecentMatchReportsSuccessAction |
    GetRecentMobilyticsReportsSuccessAction |
    GetRecentReportsFailureAction |
    SetReportProgress |
    SetDeletingReportAction |
    SetDeletingReportSuccessAcction |
    DeleteReportInitiateAction;

export const SET_LOADING_REPORTS = "SET_LOADING_REPORTS";
export const SET_DELETING_REPORT = "SET_DELETING_REPORT";
export const GET_REPORTS_INITIATE = "GET_REPORTS_INITIATE";
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS";
export const GET_REPORTS_FAILURE = "GET_REPORTS_FAILURE";
export const GET_RECENT_REPORTS_INITIATE = "GET_RECENT_REPORTS_INITIATE";
export const GET_RECENT_REPORTS_SUCCESS = "GET_RECENT_REPORTS_SUCCESS";
export const GET_RECENT_MATCH_REPORTS_SUCCESS = "GET_RECENT_MATCH_REPORTS_SUCCESS";
export const GET_RECENT_MOBILYTICS_REPORTS_SUCCESS = "GET_RECENT_MOBILYTICS_REPORTS_SUCCESS";
export const GET_RECENT_REPORTS_FAILURE = "GET_RECENT_REPORTS_FAILURE";
export const SET_REPORT_PROGRESS = "SET_REPORT_PROGRESS";
export const SET_DELETING_REPORT_SUCCESS = "SET_DELETING_REPORT_SUCCESS";
export const DELETE_REPORT_INITIATE = "DELETE_REPORT_INITIATE";
